import React from "react";
import ReactDOM from "react-dom/client";
import "slick-carousel/slick/slick.css";
import {Provider} from "react-redux";
import {store} from "./store/store";
import App from "./App";
import "./index.css";
import Whatsapp from "./components/Whattsapp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <App />
        <Whatsapp />
    </Provider>
);
